/**
 * Custom hook to determine if the current user has edit permissions.
 *
 * Edit permissions are now granted to all authenticated users.
 * The backend controls editability per case via status_flags
 * (can_update_input / can_update_output).
 *
 * @returns {boolean} true if user can edit, false otherwise
 */

export const useCanEdit = (): boolean => {
  return true;
};
